import type { PropsWithChildren } from 'react';

import { SheetContentStyled } from './styles/SheetContentStyled'
import { useInternalSheetContext } from '../../InternalSheetContext'

interface ISheetContentProps {}

export const SheetContent = ({
  children,
}: PropsWithChildren<ISheetContentProps>) => {
  useInternalSheetContext()

  return <SheetContentStyled>{children}</SheetContentStyled>
}
